import { styled } from '@mui/material'

export const FullScreenIframe = styled('iframe')({
  position: 'fixed',
  inset: 0,
  border: 'none',
})
